export type TestEnv = 'development' | 'staging' | 'local';

const SECONDS = 1000; // ms

export enum TIMEOUT {
  SHORT_TIMEOUT = 3 * SECONDS,
  MEDIUM_TIMEOUT = 5 * SECONDS,
  LONG_TIMEOUT = 20 * SECONDS,
  SELECTOR_TIMEOUT = 30 * SECONDS,
  URL_TIMEOUT = 60 * SECONDS,
}

export enum APPINPUTTYPE {
  IMAGE_TYPE = 'Image/Video',
  TEXT_TYPE = 'Text/Document',
}

export enum TASK_TYPE {
  CLASSIFICATION = 'Classification',
  DETECTION = 'Detection',
  SEGMENTATION = 'Segmentation',
}

export enum TASK_ASSIST {
  NO = 'No',
  YES = 'Yes',
}

export enum SHARING_TASK {
  NO = 'No',
  YES = 'Yes',
}
export enum INPUT_TYPES {
  FILES = 'files',
  TEXT = 'text',
  URL = 'url',
}

export enum CONCEPTNAMES {
  CAT = 'cat',
  DOG = 'dog',
  PERSON = 'person',
}

export type WORKFLOWTYPE = { changeType: boolean; type: string };

export type UPLOADFILETYPE =
  | string
  | string[]
  | { name: string; mimeType: string; buffer: Buffer }
  | { name: string; mimeType: string; buffer: Buffer }[];
